/* eslint-disable no-nested-ternary */
import { Box, Divider, Hidden, Paper, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import i18n from '@utils/i18n';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Logo } from '@svg/logo/logo_blue.svg';
// import { ReactComponent as LogoWhite } from 'assets/svg/logo_white.svg';
import LogoBlack from '@svg/logo/logo_black.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from '@components/modals';
import Link from '@components/LocalizedLink';
import btnMini from '@svg/menu/icon-menu-bl.svg';

import closeMini from '@svg/menu/icon-close.svg';
import { ReactComponent as LanguageIcon } from '@svg/menu/language-line.svg';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { setLang } from '@store/reducers/appReducer';

import { makeStyles } from '@mui/styles';
import env from '@constants/env';

const aboutUs = i18n.getFixedT(null, null, 'pages.contactForm');
const lang = localStorage.getItem('i18nextLng')?.toLowerCase() || 'ko';
const titles = [aboutUs('title'), aboutUs('consultingReq'), ''];

const useStyles = makeStyles((theme) => ({
  root: {},
  on: {},
  tab_list: {
    transitionDuration: '500ms'
  },
  menu_items_light: {
    padding: '8px 8px',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',

    '& $menu_items': {
      color: '#202020 ',
      letterSpacing: '-0.8px'
    },
    '&:hover': {
      '& $menu_items': {
        color: '#244EE2 '
      }
    }
  },
  menu_items_dark: {
    padding: '8px 8px',
    alignItems: 'center',
    justifyContent: 'center',

    '& $menu_items': {
      color: '#202020 ',
      letterSpacing: '-0.8px'
    },
    '&:hover': {
      color: '#244EE2',
      '& $menu_items': {
        color: '#244EE2'
      }
    }
  },

  lang_menu_light: {
    padding: '10px 12px 10px 16px',
    height: '40px',
    minWidth: '73px',

    alignItems: 'center',
    border: '1px solid #212121',
    justifyContent: 'center',
    position: 'relative',

    '& $menu_items': {
      color: '#212121 !important'
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
  },
  lang_menu_dark: {
    padding: '10px 12px 10px 16px',
    height: '40px',
    minWidth: '73px',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #364DD1',

    '& $menu_items': {
      color: '#364DD1 !important',
      fontWeight: 500,
      fontSize: 16
    },
    '&:hover': {
      backgroundColor: 'rgba(36, 78, 226, 0.05)'
    }
  },

  selectTransparent: {
    backgroundColor: 'transparent',
    border: '1px solid #FFFFFF',
    color: '#FFFFFF',
    fontSize: 16
  },
  menu_items: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  img: {
    width: 'auto',
    height: '54px',
    [theme.breakpoints.down('md')]: {
      height: '28px'
    }
  }
}));
const styles = `
  @keyframes fade-down-open {
    0% {
      opacity: 0;
      max-height: 0;
    }
    100% {
      opacity: 1;
      max-height: 1000px;
    }
  }

  @keyframes fade-down-close {
    0% {
      opacity: 1;
      max-height: 1000px; /* Adjust as needed */
    }
    100% {
      opacity: 0;
      max-height: 0;
    }
  }
`;

const NavContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '24px'
}));

const NavItem = styled(Box)(({ theme, isSticky }) => ({
  position: 'relative',
  cursor: 'pointer',

  padding: '12px 8px',
  '&:hover': {
    '& .dropdown-menu': {
      opacity: 1,
      visibility: 'visible'
    }
  }
}));

const NavLink = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 500,
  color: '#212121',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  letterSpacing: '-0.8px',
  flexDirection: 'row'
}));

const DropdownMenu = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  minWidth: '100%',
  maxWidth: 250,
  width: 'auto',
  top: '130%',
  left: 0,
  backgroundColor: 'white',
  border: '1px solid #F2F2F2',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: 0,
  zIndex: 1000,
  opacity: 0,
  visibility: 'hidden'
}));

const DropdownItem = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  padding: theme.spacing(1),
  '&:hover': {
    backgroundColor: '#f0f0f0'
  }
}));
const normalizePath = (pathname) => {
  if (!pathname) return '/';

  // Remove trailing slash
  let path = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  // Remove /en prefix
  if (path.startsWith('/en')) {
    path = path.replace('/en', '') || '/';
  }
  return path;
};

const isActive = (pathname, routeKeyword) => {
  const path = normalizePath(pathname);

  if (routeKeyword === '') {
    return path === '/';
  }

  const routePath = `/${routeKeyword}`;
  return path === routePath || path.startsWith(`${routePath}/`);
};

const NavbarFixed = () => {
  const dispatch = useDispatch();
  const [activeLink, setActiveLink] = useState(null);
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  const classes = useStyles();

  const langOptions = [
    {
      value: 'ko',
      label: 'KR'
    },
    { value: 'en', label: 'EN' }
  ];
  const navigate = useNavigate();

  const navList = [
    {
      title: t('pages.homepage.navbar.company-introduction'),
      href: '/',
      routeKeyword: '/',
      children: [
        {
          title: 'BI',
          href: env.biUrl || 'https://bi.workershigh.com'
        }
      ]
    },
    {
      title: t('pages.homepage.navbar.media'),
      href: '/media',
      routeKeyword: 'media'
    },
    {
      title: t('pages.homepage.navbar.announcements'),
      href: '/notice',
      routeKeyword: 'notice'
    },
    {
      title: t('pages.homepage.navbar.careers'),
      href: '/career',
      routeKeyword: 'career'
    },
    {
      title: t('pages.homepage.navbar.flagshop'),
      href: env.flagshopUrl || 'https://flagshop.ai/',
      blank: true,
      routeKeyword: 'flagshop'
    }
  ];

  const lang = localStorage.getItem('i18nextLng') || 'ko';

  const [openMo, setOpenMo] = useState(false);

  const handleLanguageChange = (value) => {
    // Determine current route without language prefix
    let path = pathname;

    // Remove '/en' prefix if exists
    if (path.startsWith('/en')) {
      path = path.replace('/en', '');
    }

    // Construct new path based on language
    const newPath = value === 'en' ? `/en${path}` : path || '/';
    dispatch(setLang(value));
    localStorage.setItem('i18nextLng', value); // Save preference
    navigate(newPath);
  };
  useEffect(() => {
    const handleScroll = () => {
      const winST = window.pageYOffset || document.documentElement.scrollTop;

      if (winST > 0) {
        // Change 64 to the point where you want to trigger sticky state
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // Empty dependency array ensures effect runs only once
  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsSticky(false);
  //   }, 0);
  // }, []);
  return (
    <Stack
      id="navBarHeader"
      sx={{
        position: 'fixed',
        display: 'flex',
        backgroundColor: isSticky ? '#FFFFFF' : 'transparent',
        zIndex: 70,
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: isSticky && '0px 2px 4px -1px rgba(95, 94, 94, 0.2)',
        height: { md: '80px', xs: '54px', xl: '80px', sm: '72px' },
        // Solid background when sticky

        transition:
          'background-color 200ms ease-in-out, border-bottom 500ms ease-in-out' // Smooth transition for background color change
      }}
    >
      <Stack
        // id="menu"
        // className="tab_list"

        sx={{
          width: { md: '75%', lg: '100%', xs: '100%' },
          height: '100%',
          px: { lg: '320px', xs: '20px', md: 0, sm: '40px' },
          maxWidth: '1920px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Stack sx={{ cursor: 'pointer', mr: { md: 10 }, ml: { md: 0 } }}>
            <Link
              href="/"
              underline="none"
              color="inherit"
              style={{ height: '27px' }}
              aria-label="Navigate to home page"
            >
              <img
                src={LogoBlack}
                alt="logo"
                style={{ width: '172px', height: '27px', objectFit: 'cover' }}
              />
            </Link>
          </Stack>
        </Stack>

        <Stack
          className="button-script"
          sx={{ flexDirection: 'row' }}
          alignItems="center"
          gap="24px"
        >
          <Hidden smDown>
            {' '}
            <NavContainer>
              {navList.map(({ title, href, children, routeKeyword }, index) => (
                <NavItem
                  key={title}
                  className={
                    isSticky
                      ? classes.menu_items_dark
                      : classes.menu_items_light
                  }
                  isSticky={isSticky}
                  onMouseEnter={() => setActiveLink(index)}
                  onMouseLeave={() => setActiveLink(null)}
                >
                  <NavLink
                    className={classes.menu_items}
                    onClick={() => {
                      setActiveLink(index);
                    }}
                    sx={{
                      color: isActive(pathname, routeKeyword)
                        ? '#244EE2 !important'
                        : '#212121 !important',
                      letterSpacing: '-0.8px !important'
                    }}
                  >
                    <Link
                      href={href}
                      style={{ color: 'inherit', textDecoration: 'none' }}
                      aria-label={`Navigate to ${title}`}
                      rel={
                        href.startsWith('http')
                          ? 'noopener noreferrer'
                          : undefined
                      }
                    >
                      {' '}
                      {title}
                    </Link>
                  </NavLink>

                  {children ? (
                    <>
                      <div
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          width: '100%',
                          height: '30%',
                          pointerEvents: 'auto',
                          zIndex: 999
                        }}
                      />
                      <DropdownMenu className="dropdown-menu">
                        {children.map(
                          ({ title: childTitle, href: childHref }) => (
                            <Link
                              key={childTitle}
                              href={childHref}
                              underline="none"
                              color="inherit"
                              aria-label={`Navigate to ${childTitle}`}
                              target={
                                childHref.startsWith('http')
                                  ? '_blank'
                                  : undefined
                              }
                              rel={
                                childHref.startsWith('http')
                                  ? 'noopener noreferrer'
                                  : undefined
                              }
                            >
                              <DropdownItem> {childTitle}</DropdownItem>
                            </Link>
                          )
                        )}
                      </DropdownMenu>
                    </>
                  ) : null}
                </NavItem>
              ))}
            </NavContainer>
          </Hidden>
          <Hidden smDown>
            <Stack
              className={
                isSticky ? classes.lang_menu_dark : classes.lang_menu_light
              }
              sx={{ position: 'relative', cursor: 'pointer' }}
              onMouseEnter={() => setActiveLink('lang')}
              onMouseLeave={() => setActiveLink(null)}
            >
              <Typography
                fontSize={16}
                fontWeight={500}
                className={classes.menu_items}
                onClick={() => {
                  setActiveLink('lang');
                }}
              >
                {langOptions?.find((i) => i?.value === lang)?.label}
                {langOptions ? (
                  activeLink === 'lang' ? (
                    <KeyboardArrowUpIcon sx={{ mt: 0.5 }} />
                  ) : (
                    <KeyboardArrowDownIcon sx={{ mt: 0.5 }} />
                  )
                ) : null}
              </Typography>

              {langOptions && activeLink === 'lang' && (
                <>
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      width: '100%',
                      height: '30%',
                      pointerEvents: 'auto',
                      zIndex: 999
                    }}
                  />
                  <Stack
                    sx={{
                      position: 'absolute',
                      minWidth: 73,
                      maxWidth: 250,
                      width: 'auto',
                      top: '130%', // Starting position just below the parent item
                      left: 0,
                      backgroundColor: 'white',
                      border: '1px solid #F2F2F2',
                      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                      borderRadius: '0px',
                      zIndex: 1000,
                      opacity: activeLink === 'lang' ? 1 : 0, // Control visibility
                      transform:
                        activeLink === 'lang'
                          ? 'translateY(0)'
                          : 'translateY(-50px)', // Control position
                      transition:
                        'opacity, height 500ms ease-in-out, transform 500ms ease-in-out', // Transition properties
                      pointerEvents: activeLink === 'lang' ? 'auto' : 'none' // Ens
                    }}
                  >
                    {langOptions.map(({ value, label }) => (
                      <Typography
                        key={label}
                        fontSize={14}
                        fontWeight={500}
                        sx={{
                          whiteSpace: 'nowrap',
                          p: 1,
                          '&:hover': {
                            backgroundColor: '#f0f0f0'
                          }
                        }}
                        onClick={() => {
                          handleLanguageChange(value);
                        }}
                      >
                        {label}
                      </Typography>
                    ))}
                  </Stack>
                </>
              )}
            </Stack>
          </Hidden>
          <Hidden smUp>
            <Stack onClick={() => setOpenMo(!openMo)}>
              <img src={btnMini} alt="btn" />
            </Stack>
          </Hidden>
        </Stack>
      </Stack>

      <Modal
        open={openMo}
        setOpen={setOpenMo}
        title={null}
        sx={{
          dialogContent: {
            p: 0
          }
        }}
      >
        <MenuMobile
          setOpenMo={setOpenMo}
          langOptions={langOptions}
          handleLanguageChange={handleLanguageChange}
          navList={navList}
          activeLink={activeLink}
          setActiveLink={setActiveLink}
          dispatch={dispatch}
        />
      </Modal>
    </Stack>
  );
};

const MenuMobile = ({
  setOpen,
  setOpenMo,
  navList = [],
  activeLink,
  langOptions,
  setActiveLink,
  dispatch,
  handleLanguageChange
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    setActiveLink((prev) => {
      const currentRoute = navList.find((i) =>
        pathname?.includes(i.routeKeyword)
      );
      return navList.indexOf(currentRoute);
    });
  }, []);
  return (
    <Stack height="100%" bgcolor="white">
      <style>{styles}</style>
      {/* header */}
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          backgroundColor: 'white',
          width: '100%',
          px: 2.5,
          height: '63px',
          borderBottom: '1px solid #DEE2E6',
          zIndex: 1000
        }}
      >
        <Stack sx={{ cursor: 'pointer' }}>
          <Link
            href="/"
            underline="none"
            color="inherit"
            sx={{ height: '27px' }}
            aria-label="Navigate to home"
          >
            {' '}
            <Logo />
          </Link>
        </Stack>
        <Stack flexDirection="row" alignItems="center" gap={1}>
          <Stack onClick={() => setOpenMo(false)}>
            <img src={closeMini} alt="btn" />
          </Stack>
        </Stack>
      </Stack>
      <Stack
        flexDirection="column"
        alignItems="center"
        gap={2}
        mt="40px"
        height="100%"
        px={2.5}
        pb={5}
      >
        <Stack sx={{ width: '100%', flexGrow: 1 }}>
          <Stack
            className="menu-"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="space-between"
            gap={3}
          >
            {navList.map(({ title, href, routeKeyword, children }, index) => (
              <Stack key={title} sx={{ width: '100%', gap: 3 }}>
                <Stack
                  sx={{
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                  onClick={() => {
                    setActiveLink(activeLink === index ? null : index);
                  }}
                >
                  {children ? (
                    <Typography
                      fontSize={24}
                      fontWeight={700}
                      className={classes.menu_items}
                      sx={{
                        letterSpacing: '-1.2px',
                        color: isActive(pathname, routeKeyword)
                          ? '#244EE2 !important'
                          : '#212121 !important'
                      }}
                    >
                      {title}
                    </Typography>
                  ) : (
                    <Typography
                      fontSize={24}
                      fontWeight={700}
                      className={classes.menu_items}
                      sx={{
                        letterSpacing: '-1.2px',
                        color: isActive(pathname, routeKeyword)
                          ? '#244EE2 !important'
                          : '#212121 !important'
                      }}
                    >
                      <a
                        href={href}
                        style={{ color: 'inherit', textDecoration: 'none' }}
                        aria-label={`Navigate to ${title}`}
                        rel={
                          href.startsWith('http')
                            ? 'noopener noreferrer'
                            : undefined
                        }
                      >
                        {' '}
                        {title}
                      </a>
                    </Typography>
                  )}
                </Stack>

                {children && (
                  <Stack
                    sx={{
                      width: 'auto',
                      gap: 1.5
                    }}
                  >
                    {children.map(({ title: childTitle, href: childHref }) => (
                      <Link
                        key={childTitle}
                        href={childHref}
                        underline="none"
                        component="a"
                        target={
                          childHref.startsWith('http') ? '_blank' : undefined
                        }
                        rel={
                          childHref.startsWith('http')
                            ? 'noopener noreferrer'
                            : undefined
                        }
                        onClick={(e) => {
                          if (childHref.startsWith('http')) {
                            setOpenMo(false);
                            return;
                          }
                          e.preventDefault();
                          navigate(childHref);
                          setOpenMo(false);
                        }}
                        sx={{
                          fontSize: 24,
                          fontWeight: 700,
                          letterSpacing: '-1.2px',
                          whiteSpace: 'nowrap',
                          color: pathname.includes(childHref)
                            ? '#244EE2'
                            : '#212121',
                          '&:hover': {
                            textDecoration: 'none'
                          }
                        }}
                        aria-label={`Navigate to ${childTitle}`}
                      >
                        {childTitle}
                      </Link>
                    ))}
                  </Stack>
                )}
              </Stack>
            ))}
          </Stack>
        </Stack>
        {/* Language row */}
        <Stack
          sx={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',

              alignItems: 'center',
              gap: 1
            }}
          >
            <LanguageIcon />
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 1
              }}
            >
              {langOptions &&
                langOptions.map(({ value, label }, index) => (
                  <Stack
                    flexDirection="row"
                    gap={1}
                    alignItems="center"
                    key={`${value} + ${label} +`}
                  >
                    <Typography
                      fontSize={14}
                      fontWeight={700}
                      sx={{
                        whiteSpace: 'nowrap',
                        color: '#212121',
                        opacity: lang !== value && 0.3
                      }}
                      onClick={() => {
                        handleLanguageChange(value);
                      }}
                    >
                      {label}
                    </Typography>
                    {index !== langOptions.length - 1 && (
                      <Stack sx={{ height: '13px' }}>
                        <Divider
                          flexItem
                          sx={{
                            borderColor: '#212121',
                            opacity: 0.3,
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '13px'
                          }}
                          orientation="vertical"
                        />
                      </Stack>
                    )}
                  </Stack>
                ))}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default NavbarFixed;
